<template>
  <div>
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">申请数据迁移</h4>
        </Row>
        <GeneralAlert></GeneralAlert>
        <Form ref="migrateForm" :model="migrateForm" :label-width="80" :rules="migrateRule">
          <FormItem label="标题" prop="title">
            <Input v-model="migrateForm.title" placeholder="请输入标题" />
          </FormItem>
          <FormItem label="源实例" prop="source_instance">
            <Select v-model="migrateForm.source_instance" placeholder="请选择源实例" filterable transfer @on-change="getSourceDB" clearable label-in-value ref="sourceInstance">
              <OptionGroup label="MySQL">
                <Option v-for="item in instanceList.mysql" :value="'mysql_' + item.id" :key="'mysql_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
              <!--<OptionGroup label="MongoDB">-->
              <!--<Option v-for="item in instanceList.mongodb" :value="'mongodb_' + item.id" :key="'mongodb_' + item.id">{{ item.name }}</Option>-->
              <!--</OptionGroup>-->
              <!--<OptionGroup label="SQL Server">-->
                <!--<Option v-for="item in instanceList.sqlserver" :value="'sqlserver_' + item.id" :key="'sqlserver_' + item.id">{{ item.name }}</Option>-->
              <!--</OptionGroup>-->
            </Select>
          </FormItem>
          <FormItem label="源数据库" prop="origin_db">
            <Select @on-change="getTables" v-model="migrateForm.origin_db" clearable filterable ref="sourceDatabase">
              <Option v-for="item in sourceDB" :value="item" :key="item" :label="item"></Option>
            </Select>
          </FormItem>
          <FormItem label="源数据表" prop="origin_tab">
            <transfer :data="tableList" :target-keys="migrateForm.origin_tab" :list-style="listStyle" @on-change="tableChange" filterable :render-format="render"></transfer>
          </FormItem>
          <FormItem label="目标实例" prop="target_instance">
            <Select v-model="migrateForm.target_instance" placeholder="请选择目标实例" filterable transfer clearable @on-change="getTargetDB" label-in-value ref="targetInstance">
              <OptionGroup label="MySQL" v-if="!migrateForm.instance_type || migrateForm.instance_type === 'mysql'">
                <Option v-for="item in instanceList.mysql" :value="'mysql_' + item.id" :key="'mysql_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
              <!--<OptionGroup label="MongoDB">-->
              <!--<Option v-for="item in instanceList.mongodb" :value="'mongodb_' + item.id" :key="'mongodb_' + item.id">{{ item.name }}</Option>-->
              <!--</OptionGroup>-->
              <!--<OptionGroup label="SQL Server" v-if="!migrateForm.instance_type || migrateForm.instance_type === 'sqlserver'">-->
                <!--<Option v-for="item in instanceList.sqlserver" :value="'sqlserver_' + item.id" :key="'sqlserver_' + item.id">{{ item.name }}</Option>-->
              <!--</OptionGroup>-->
            </Select>
          </FormItem>
          <FormItem label="目标数据库" prop="target_db">
            <Select v-model="migrateForm.target_db" clearable filterable placeholder="默认新建数据库">
              <Option v-for="item in targetDB" :value="item" :key="item" :label="item"></Option>
            </Select>
          </FormItem>
          <FormItem label="克隆方式" prop="migrate_type">
            <RadioGroup v-model="migrateForm.migrate_type">
              <Radio :label="0">表结构</Radio>
              <Radio :label="1">表结构+数据</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="克隆选项" prop="migrate_option">
            <CheckboxGroup v-model="migrateForm.migrate_option">
              <Checkbox :label="0">视图</Checkbox>
              <Checkbox :label="1">存储过程</Checkbox>
              <Checkbox :label="2">定时事件</Checkbox>
              <Checkbox :label="3">克隆前是否备份</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="申请说明" prop="application_content">
            <Input v-model="migrateForm.application_content" :rows="2" type="textarea" placeholder="" />
          </FormItem>
          <FormItem style="text-align: center;">
            <Button type="primary" @click="submit">提交</Button>
            <Button style="margin-left: 8px" @click="$router.go(-1)">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { applyDbDataMigrateFlow } from '@/api/workflow/db_data_migrate_flow'
import { getAllInstance } from '@/api/database'
import { showDatabaseList as showMysqlDatabaseList,
  showTableList as showMysqlTableList } from '@/api/mysql'
import { showDatabaseList as showSqlServerDatabaseList,
  showTableList as showSqlServerTableList } from '@/api/sqlserver'
import GeneralAlert from '../components/general-alert'
export default {
  name: 'add',
  components: {
    GeneralAlert
  },
  data () {
    return {
      migrateForm: {
        title: '',
        instance_type: '',
        source_instance: '',
        source_instance_name: '',
        origin_db: '',
        origin_tab: [],
        target_instance: '',
        target_instance_name: '',
        target_db: '',
        migrate_type: null,
        migrate_option: [],
        application_content: ''
      },
      migrateRule: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        source_instance: [{ required: true, message: '请选择源实例', trigger: 'change' }],
        origin_db: [{ required: true, message: '请选择源数据库', trigger: 'change' }],
        origin_tab: [{ type: 'array', required: true, message: '请选择源数据表', trigger: 'blur' }],
        target_instance: [{ required: true, message: '请选择目标实例', trigger: 'change' }],
        migrate_type: [{ type: 'number', required: true, message: '请选择克隆方式', trigger: 'blur' }]
      },
      sourceDB: [],
      targetDB: [],
      tableList: [],
      migrateDetail: {},
      instanceList: {
        mysql: [],
        mongodb: [],
        sqlserver: []
      },
      listStyle: {
        width: '500px',
        height: '300px'
      }
    }
  },
  mounted: function () {
    this.getInstances()
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.getInstances()
    }
  },
  methods: {
    submit () {
      this.$refs.migrateForm.validate((valid) => {
        if (valid) {
          let reqData = {
            title: this.migrateForm.title,
            instance_type: this.migrateForm.instance_type,
            origin_instance_id: this.migrateForm.source_instance.split('_')[1],
            origin_instance_name: this.migrateForm.source_instance_name,
            target_instance_id: this.migrateForm.target_instance.split('_')[1],
            target_instance_name: this.migrateForm.target_instance_name,
            origin_db: this.migrateForm.origin_db,
            target_db: this.migrateForm.target_db,
            origin_tab: this.migrateForm.origin_tab.join(','),
            application_content: this.migrateForm.application_content,
            is_new_db: this.migrateForm.target_db ? 0 : 1,
            is_export_data: this.migrateForm.migrate_type,
            is_export_view: this.migrateForm.migrate_option.indexOf(0) > -1 ? 1 : 0,
            is_export_routine: this.migrateForm.migrate_option.indexOf(1) > -1 ? 1 : 0,
            is_export_event: this.migrateForm.migrate_option.indexOf(2) > -1 ? 1 : 0,
            is_export_target: this.migrateForm.migrate_option.indexOf(3) > -1 ? 1 : 0
          }
          this.submitting = true
          applyDbDataMigrateFlow(reqData).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$router.push({ name: 'dbDataMigrateFlowDetail', params: { id: res.data.id } })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 获取实例列表
    getInstances () {
      this.$refs.sourceInstance.clearSingleSelect()
      this.$refs.targetInstance.clearSingleSelect()
      getAllInstance({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.instanceList = res.data
      })
    },
    // 获取源数据库
    getSourceDB (instanceObj) {
      let instance = instanceObj.value
      this.migrateForm.source_instance_name = instanceObj.label
      if (this.migrateForm.origin_db) {
        this.$refs.sourceDatabase.clearSingleSelect()
      }
      this.sourceDB = []
      this.tableList = []
      if (!instance) {
        return
      }
      let instanceId = instance.split('_')[1]
      let instanceType = instance.split('_')[0]
      this.migrateForm.instance_type = instanceType
      if (this.migrateForm.target_instance) {
        if (!(this.migrateForm.target_instance.startsWith(instanceType) && this.migrateForm.source_instance.startsWith(instanceType))) {
          this.$refs.targetInstance.clearSingleSelect()
        }
      }
      if (instanceType === 'mysql') {
        showMysqlDatabaseList({ id: instanceId }).then(res => {
          this.sourceDB = res.data.results
        })
      } else if (instanceType === 'sqlserver') {
        showSqlServerDatabaseList({ id: instanceId }).then(res => {
          this.sourceDB = res.data.results
        })
      }
    },
    // 获取目标数据库
    getTargetDB (instanceObj) {
      let instance = instanceObj.value
      this.migrateForm.target_instance_name = instanceObj.label
      this.targetDB = []
      this.migrateForm.target_db = ''
      if (!instance) {
        return
      }
      let instanceId = instance.split('_')[1]
      let instanceType = instance.split('_')[0]
      if (instanceType === 'mysql') {
        showMysqlDatabaseList({ id: instanceId }).then(res => {
          this.targetDB = res.data.results
        })
      } else if (instanceType === 'sqlserver') {
        showSqlServerDatabaseList({ id: instanceId }).then(res => {
          this.targetDB = res.data.results
        })
      }
    },
    // 获取数据表
    getTables (database) {
      this.migrateForm.origin_tab = []
      this.tableList = []
      if (!database) {
        return
      }
      if (this.migrateForm.source_instance.split('_')[0] === 'mysql') {
        showMysqlTableList({ id: this.migrateForm.source_instance.split('_')[1], db: database }).then(res => {
          let result = res.data.results
          for (let i in result) {
            this.tableList.push({
              key: result[i],
              label: result[i]
            })
          }
        })
      } else if (this.migrateForm.source_instance.split('_')[0] === 'sqlserver') {
        showSqlServerTableList({ id: this.migrateForm.source_instance.split('_')[1], db: database }).then(res => {
          let result = res.data.results
          for (let i in result) {
            this.tableList.push({
              key: result[i],
              label: result[i]
            })
          }
        })
      }
    },
    tableChange (newTargetKeys) {
      this.migrateForm.origin_tab = newTargetKeys
    },

    render (item) {
      return `<span title="${item.key}">${item.key}</span>`
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
</style>
